import { render, staticRenderFns } from "./ReceiptApply.vue?vue&type=template&id=2bd3327d&"
import script from "./ReceiptApply.vue?vue&type=script&lang=ts&"
export * from "./ReceiptApply.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptApply.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports